import { API_BASE_URL } from '../config';

const baseUrl= API_BASE_URL;

export const getFiltersForCustomPage = async (
  dynamicUrl,
  language,
) => {
  // Construct the API URL with dynamic values
  const apiUrl = `${baseUrl}custom_page?countryCode=${language}&lang=${language}&url=${dynamicUrl}`;

  try {
    const response = await fetch(apiUrl);
    const dataJson = await response.json();
    const data = dataJson.data;


    // Map API response to the Redux state structure
    const filters = {
      city: data.city || "",
      capacity: data.capacity || "",
      usages: data.type ? [data.type] : [],
      postal_code: data.postal_code || "",
      place_type_id: data.place_type_id || null,
      lat_p1: data.lat1 || "",
      lat_p2: data.lat2 || "",
      lng_p1: data.lon1 || "",
      lng_p2: data.lon2 || "",
      place_style: data.place_style_id || null,
    };

    // Return ALL data including meta and title
    return {
      filters,
      subtitle: data.subtitle,
      text: data.text,
      title: data.title, // Add this
      meta: data.meta // Add this - THIS IS WHAT WAS MISSING!
    };
  } catch (error) {
    console.error("Error fetching filters:", error);
    throw error;
  }
};